export const noConnectionCopy = {
  title: 'Connect your YouTube Channel',
  message: 'To see account insights you are required to connect your YouTube Channel.',
};

export const reconnectionCopy = {
  title: 'Connect your YouTube Channel',
  message: 'To see account insights you are required to connect your YouTube Channel.',
};

export const noAccessCopy = {
  noAccessMessage:
    'Dash Social brings you all of the insights you love, including YouTube! Ask your Dash Social administrator to provide you access.',
  noBrandPermission: "Looks like this feature isn't included in your plan!",
  noUserPermission: "Looks like you don't have permission to use this feature!",
};

export const timeScaleTypes = {
  DAILY: 'DAILY',
  MONTHLY: 'MONTHLY',
};

export const tooltips = {
  subscribersChart:
    'The number of people who have subscribed to your channel during the selected date range.',
  metricChart: {
    VIEWS: 'The number of times your videos have been viewed.',
    AVG_VIEW_DURATION: 'The average amount of time that viewers watched per video view.',
    COMMENTS: 'The total number of comments your videos received.',
    LIKES: 'The total number of likes that your videos received.',
    ENGAGEMENTS:
      'The total number of engagements your videos received. Total Engagements  = Likes + Dislikes + Comments + Shares',
    ESTIMATED_SECONDS_WATCHED:
      'The total amount of time that viewers watched videos on your channel.',
  },
  topPerformingVideos: 'Your highest performing videos published within the selected date range.',
  totalSubscribers:
    'The total number of users who have subscribed to your channel by the last day of the selected date range.',
  netNewSubscribers:
    'The net new number of users who have subscribed to your channel during the selected date range.',
  avgViewDuration: 'The average amount of time that viewers watched per video view.',
  totalEngagements:
    'The total number of engagements on your videos during the selected date range. Total Engagements = Likes + Dislikes + Comments + Shares',
  watchTime:
    'The total amount of time that viewers watched videos on your channel during the selected date range.',
  trendingVideos:
    'Your videos that received the highest number of views during the selected date range.',
  totalVideoViews: 'Total Video Views',
  avgViewPercentage: 'Avg. Percentage Viewed',
};

export const noVideosReportingPeriod = 'No YouTube videos found during this reporting period.';

export const privacyStatusEnum = {
  PRIVATE: 'private',
  UNLISTED: 'unlisted',
};

export const metrics = {
  AVG_VIEW_PERCENTAGE: {
    value: 'YOUTUBE_AVG_VIEW_PERCENTAGE',
    field: 'avgViewPercentage',
    label: 'Avg. Percentage Viewed',
  },
  AVG_VIEW_DURATION: {
    value: 'YOUTUBE_AVG_VIEW_DURATION',
    field: 'avgViewDuration',
    label: 'Avg. View Duration',
  },
  CARD_CLICKS: {
    value: 'YOUTUBE_CARD_CLICKS',
    field: 'cardClicks',
    label: 'Card Clicks',
  },
  CARD_CLICK_RATE: {
    value: 'YOUTUBE_CARD_CLICK_RATE',
    field: 'cardClickRate',
    label: 'Card Click Rate',
  },
  CARD_TEASER_CLICKS: {
    value: 'YOUTUBE_CARD_TEASER_CLICKS',
    field: 'cardTeaserClicks',
    label: 'Card Teaser Clicks',
  },
  CARD_TEASER_CLICK_RATE: {
    value: 'YOUTUBE_CARD_TEASER_CLICK_RATE',
    field: 'cardTeaserClickRate',
    label: 'Card Teaser Click Rate',
  },
  CARD_TEASER_IMPRESSIONS: {
    value: 'YOUTUBE_CARD_TEASER_IMPRESSIONS',
    field: 'cardTeaserImpressions',
    label: 'Card Teaser Impressions',
  },
  COMMENTS: {
    value: 'YOUTUBE_COMMENTS',
    field: 'comments',
    label: 'Comments',
  },
  DISLIKES: {
    value: 'YOUTUBE_DISLIKES',
    field: 'dislikes',
    label: 'Dislikes',
  },
  LIKES: {
    value: 'YOUTUBE_LIKES',
    field: 'likes',
    label: 'Likes',
  },
  PREMIUM_VIEWS: {
    value: 'YOUTUBE_PREMIUM_VIEWS',
    field: 'premiumViews',
    label: 'Premium Views',
  },
  PREMIUM_WATCH_TIME: {
    value: 'YOUTUBE_EST_PREMIUM_SECONDS_WATCHED',
    field: 'estPremiumSecondsWatched',
    label: 'Premium Watch Time',
  },
  SUBSCRIBERS: {
    value: 'YOUTUBE_SUBSCRIBERS',
    field: 'subscribers',
    label: 'Subscribers',
  },
  SHARES: {
    value: 'YOUTUBE_SHARES',
    field: 'shares',
    label: 'Shares',
  },
  TOTAL_ENGAGEMENTS: {
    value: 'YOUTUBE_ENGAGEMENTS',
    field: 'engagements',
    label: 'Total Engagements',
  },
  VIDEOS_ADDED_TO_PLAYLIST: {
    value: 'YOUTUBE_VIDEOS_ADDED_TO_PLAYLIST',
    field: 'videosAddedToPlaylist',
    label: 'Added to Playlist',
  },
  VIEWS: {
    value: 'YOUTUBE_VIEWS',
    field: 'views',
    label: 'Video Views',
  },
  WATCH_TIME: {
    value: 'YOUTUBE_EST_SECONDS_WATCHED',
    field: 'estSecondsWatched',
    label: 'Watch Time',
  },
};

export const metricLabels = Object.values(metrics).reduce((acc, v) => {
  acc[v.field] = v.label;
  return acc;
}, {});

export const defaultCardMetrics = [
  metrics.VIEWS.field,
  metrics.AVG_VIEW_DURATION.field,
  metrics.TOTAL_ENGAGEMENTS.field,
  metrics.AVG_VIEW_PERCENTAGE.field,
];

export const youtubeMediaCardDefaults = {
  metrics: defaultCardMetrics,
  labels: {
    [metrics.VIEWS.field]: 'Video Views',
    [metrics.AVG_VIEW_DURATION.field]: 'Avg. View Duration',
    [metrics.TOTAL_ENGAGEMENTS.field]: 'Total Engagements',
    [metrics.AVG_VIEW_PERCENTAGE.field]: 'Avg. % Viewed',
  },
};

export const internalTrafficSourceMap = {
  ADVERTISING: 'YouTube Advertising',
  SUBSCRIBER: 'Browse Features',
  YTCHANNEL: 'Channel Pages',
  YTSEARCH: 'YouTube Search',
  RELATEDVIDEO: 'Suggested Videos',
  YTRELATED: 'Suggested Videos',
  YTOTHERPAGE: 'Other YouTube Features',
  ANNOTATION: 'Video Cards',
  PLAYLIST: 'Playlists',
  NOTIFICATION: 'Notifications',
  YTPLAYLISTPAGE: 'Playlist Pages',
  CAMPAIGNCARD: 'Campaign Cards',
  ENDSCREEN: 'End Screens',
  SHORTS: 'Shorts',
  PROMOTED: 'Promoted',
};

export const ageGroupLabelMap = {
  // these are the old age group labels, but we are keeping them for backward compatibility
  'age13-17': '13-17 years',
  'age18-24': '18-24 years',
  'age25-34': '25-34 years',
  'age35-44': '35-44 years',
  'age45-54': '45-54 years',
  'age55-64': '55-64 years',
  'age65-': '65+ years',
  // below are new age group labels
  age1317Female: '13-17 years females',
  age1824Female: '18-24 years females',
  age2534Female: '25-34 years females',
  age3544Female: '35-44 years females',
  age4554Female: '45-54 years females',
  age5564Female: '55-64 years females',
  // Camelizing `age65-_female` swallows the hyphen.
  age65Female: '65+ years females',
  age1317Male: '13-17 years males',
  age1824Male: '18-24 years males',
  age2534Male: '25-34 years males',
  age3544Male: '35-44 years males',
  age4554Male: '45-54 years males',
  age5564Male: '55-64 years males',
  age65Male: '65+ years males',
};

export const DEMO_YOUTUBE_VIDEO_URL = 'https://www.youtube.com/watch?v=ZPBRlTQsolA';
export const DEMO_VIDEO_SOURCE_ID = 'ZPBRlTQsolA';

export const youtubeCommentsRequiredScopes = ['https://www.googleapis.com/auth/youtube.force-ssl'];
